import React from 'react';
import { Link } from 'react-router-dom';
import { Plug, ArrowRight } from 'lucide-react';

const ZoteroIntegration = () => {
  return (
    <section id="zotero" className="my-20">
      <div className="text-center mb-10">
        <div className="inline-block mb-4">
          <div className="flex items-center justify-center px-4 py-1.5 rounded-full bg-sortio-primary/10 border border-sortio-primary/20">
            <Plug className="mr-2 text-sortio-primary" size={14} />
            <span className="text-xs font-medium uppercase tracking-wider text-sortio-primary">
              Shipping: Zotero integration
            </span>
          </div>
        </div>
        <h2 className="text-3xl sm:text-4xl font-semibold mb-4 tracking-tight text-apple-50">
          Built for Zotero
        </h2>
      </div>

      <div className="bg-apple-800/40 backdrop-blur-sm rounded-2xl border border-apple-700/50 p-8 sm:p-10 max-w-3xl mx-auto space-y-5">
        <p className="text-apple-200 text-base sm:text-lg leading-relaxed">
          The Zotero integration is shipping in the next Sortio release, as the pilot of our wider
          batched integrations effort (dotloop, Buildium, Rent Manager are landing alongside). It
          uses Zotero's API-key auth, lists your existing collections and items, parses each PDF\'s
          title and DOI, enriches via Crossref where useful, and uploads as a Zotero item with the
          PDF attached. Collection matching mirrors how Sortio routes documents to Clio matters or
          property units in the other integrations.
        </p>
        <p className="text-apple-200 text-base sm:text-lg leading-relaxed">
          Today you can use Sortio with Zotero as a pre-step: point it at your Downloads folder, let
          it rename and route the PDFs, then drag the renamed files into Zotero (which will
          re-parse the metadata correctly because the filenames now match the content). When the
          integration goes live, that drag-and-drop step disappears.
        </p>
        <p className="text-apple-200 text-base sm:text-lg leading-relaxed">
          For researchers without Zotero, Sortio works as a standalone organizer. The same
          author-year-title rename pattern, project folder routing, and supplemental data linking
          works against a plain filesystem library.
        </p>
        <div className="pt-4">
          <Link to="/integrations" className="inline-flex items-center text-sortio-primary hover:text-sortio-secondary transition-colors text-sm font-medium">
            See all integrations <ArrowRight className="ml-1.5" size={14} />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ZoteroIntegration;
